// extracted by mini-css-extract-plugin
export var anim = "banner-module--anim--2dD-g";
export var banner = "banner-module--banner--m+W39";
export var elemContainer = "banner-module--elemContainer--2GLxC";
export var icon = "banner-module--icon--EvMa9";
export var mouve = "banner-module--mouve--WiJzi";
export var warning = "banner-module--warning--3U3xA";
export var warning2 = "banner-module--warning2--PI9cO";